/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Filter_InternalInputs */

const vi_product_filter_internal = /** @type {(inputs: Product_Filter_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội bộ`)
};

/**

* @param {Product_Filter_InternalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_filter_internal = /** @type {((inputs?: Product_Filter_InternalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Filter_InternalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_filter_internal(inputs)
});